import { render, staticRenderFns } from "./agents.vue?vue&type=template&id=1d4ad600&"
import script from "./agents.vue?vue&type=script&lang=js&"
export * from "./agents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "agents.vue"
export default component.exports